import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-2a063e64"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "editor-list"
};
const _hoisted_2 = {
  class: "editor-heading"
};
const _hoisted_3 = {
  key: 0,
  class: "editor-boards"
};
const _hoisted_4 = {
  key: 1,
  class: "editor-images"
};
const _hoisted_5 = ["src"];
const _hoisted_6 = ["src"];
const _hoisted_7 = {
  class: "editor-answer"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_button = _resolveComponent("el-button");
  const _component_OpticalPathBoard = _resolveComponent("OpticalPathBoard");
  const _component_el_empty = _resolveComponent("el-empty");
  const _component_OpticalPathQuestionSelector = _resolveComponent("OpticalPathQuestionSelector");
  const _component_el_drawer = _resolveComponent("el-drawer");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.data.totalQuestionSize, index => {
    return _openBlock(), _createElementBlock("article", {
      key: index,
      class: "editor-card"
    }, [$data.questions[index - 1] ? (_openBlock(), _createElementBlock(_Fragment, {
      key: 0
    }, [_createElementVNode("div", _hoisted_2, [_createElementVNode("strong", null, "第 " + _toDisplayString(index) + " 题", 1), _createVNode(_component_el_button, {
      type: "primary",
      plain: "",
      onClick: $event => $options.choose(index - 1)
    }, {
      default: _withCtx(() => [_createTextVNode("换题")]),
      _: 2
    }, 1032, ["onClick"])]), _createElementVNode("h3", null, _toDisplayString($data.questions[index - 1].title), 1), $options.config($data.questions[index - 1]) ? (_openBlock(), _createElementBlock("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.config($data.questions[index - 1]).cases, (knownCase, caseIndex) => {
      return _openBlock(), _createBlock(_component_OpticalPathBoard, {
        key: `case-${caseIndex}`,
        "model-value": knownCase,
        compact: "",
        "show-elements": false,
        "aria-label": `已知案例 ${caseIndex + 1}`
      }, null, 8, ["model-value", "aria-label"]);
    }), 128)), _createVNode(_component_OpticalPathBoard, {
      "model-value": $options.config($data.questions[index - 1]).target,
      compact: "",
      "show-elements": false,
      "aria-label": "新射入路径"
    }, null, 8, ["model-value"])])) : (_openBlock(), _createElementBlock("div", _hoisted_4, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.images($data.questions[index - 1].questionImages), image => {
      return _openBlock(), _createElementBlock("img", {
        key: image,
        src: image,
        alt: "题目图片"
      }, null, 8, _hoisted_5);
    }), 128)), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.images($data.questions[index - 1].optionImages), image => {
      return _openBlock(), _createElementBlock("img", {
        key: image,
        src: image,
        alt: "选项图片"
      }, null, 8, _hoisted_6);
    }), 128))])), _createElementVNode("div", _hoisted_7, "答案 " + _toDisplayString($data.questions[index - 1].rightAnswer), 1)], 64)) : (_openBlock(), _createBlock(_component_el_empty, {
      key: 1,
      description: "尚未选择题目"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_button, {
        type: "primary",
        onClick: $event => $options.choose(index - 1)
      }, {
        default: _withCtx(() => [_createTextVNode("选择题目")]),
        _: 2
      }, 1032, ["onClick"])]),
      _: 2
    }, 1024))]);
  }), 128))]), _createVNode(_component_el_drawer, {
    modelValue: $data.drawerVisible,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.drawerVisible = $event),
    title: "选择黑盒光路题目",
    size: "min(1100px, 100%)"
  }, {
    default: _withCtx(() => [_createVNode(_component_OpticalPathQuestionSelector, {
      onConfirm: $options.onSelected
    }, null, 8, ["onConfirm"])]),
    _: 1
  }, 8, ["modelValue"])], 64);
}